import React from 'react'
import Modal from '../Modal'
import { P } from '../StyledText'

interface ILogOutModal {
  open: boolean
  submitAction: () => void
  closeAction: () => void
}

export const LogOutModal = ({
  open,
  submitAction,
  closeAction,
}: ILogOutModal) => (
  <Modal
    open={open}
    handleClose={closeAction}
    action={() => {
      closeAction()
      submitAction()
    }}
    title="Log out"
    actionLabel="Log out"
  >
    <P>Are you sure you want to log out?</P>
  </Modal>
)
